<template>
  <div
    v-if="modal"
    class="stage-slide-dialog"
  >
    <Heading
      :text="modal.heading"
      class="stage-slide-dialog__heading"
      tag="h3"
      size="md"
      font-weight="ultra"
      align="center"
    />
    <Paragraph
      :text="modal.subheading"
      class="stage-slide-dialog__subheading"
    />
    <Paragraph
      :text="modal.copy"
      class="stage-slide-dialog__copy"
      align="center"
    />
  </div>
</template>

<script setup lang="ts">
import { Heading, Paragraph } from '@i22team/td-longtail-vue-components';
import type { PromotionOffer } from '~/lib/offers-by-group';
import type { StageSliderData } from '~/lib/promotions-type';

export type StageSlideComponentProps = {
  modal: StageSliderData['modal'];
  lazyLoading?: boolean;
};

const props = withDefaults(defineProps<StageSlideComponentProps>(), {});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;
.stage-slide-dialog {
  &__subheading {
    font-weight: 800;
    @include font-size(24px, 29px);
    text-align: center;
  }

  &__heading {
    color: var(--color-primary);
    margin-bottom: $grid-base * 2;
  }
}
</style>
